/** @format */

export const APPLICATION_CONFIG_ID =
  process.env.REACT_APP_APPLICATION_CONFIG_ID;
export const APPLICATION_USER_TYPE = "buyer";
export const APPLICATION_PLATFORM = 3;
